module.exports = __webpack_public_path__ + "assets/LogOut.af2d51f7d8060f12b3eefee28ca614e4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/svg/user-menu/LogOut.svg
// module id = 875
// module chunks = 0